import script from "./BreadcrumbSwitcherMenu.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./BreadcrumbSwitcherMenu.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./BreadcrumbSwitcherMenu.vue?vue&type=style&index=0&id=1e603ea5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e603ea5"]])

export default __exports__